export const projects = [
  {
    id: "grandmart",
    title: "GrandMart — Multi Outlet System",
    description:
      "Enterprise supermarket management platform with role-based access, inventory tracking, POS billing, HR payroll, and sales analytics.",
    tech: ["Java", "Spring Boot", "PostgreSQL", "Redis", "Docker"],
    category: "Backend / Enterprise",
    isPrivate: true,
    privateBadge: "🔒 PRIVATE • PROFESSIONAL PROJECT",
    github: null,
    link: null,
    images: ["/projects/neokart/1.png"],
    featured: true,
  },
  {
    id: "doob-booking",
    title: "DOOB Booking System",
    description:
      "Sports venue booking platform with real-time slot management, concurrent booking lock handles, and automated payment verification.",
    tech: ["Java", "Spring Boot", "PostgreSQL", "Spring Security"],
    category: "Backend",
    isPrivate: true,
    privateBadge: "🔒 PRIVATE • PROFESSIONAL PROJECT",
    github: null,
    link: null,
    images: ["/projects/scm/1.png"],
    featured: true,
  },
  {
    id: "smart-contact-manager",
    title: "Smart Contact Manager",
    description:
      "Production-ready Spring Boot web application featuring Google OAuth2, automated SMTP email dispatch, contact management, and dashboard analytics.",
    tech: ["Java", "Spring Boot", "MySQL", "Spring Security", "Thymeleaf"],
    category: "Backend",
    isPrivate: false,
    github: "https://github.com/GulrezSarankar/SCM.git",
    link: "https://github.com/GulrezSarankar/SCM.git",
    images: ["/projects/scm/1.png"],
    featured: false,
  },
  {
    id: "neokart",
    title: "NeoKart E-Commerce Platform",
    description:
      "Full e-commerce ecosystem built with Spring Boot and SQL Server, featuring stateless JWT authentication, Razorpay gateway, admin & customer control panels.",
    tech: ["Spring Boot", "JWT", "Razorpay", "SQL Server", "REST APIs"],
    category: "Backend",
    isPrivate: false,
    github: "https://github.com/GulrezSarankar/Live-NeoKart.git",
    link: "https://github.com/GulrezSarankar/Live-NeoKart.git",
    images: [
      "/projects/neokart/1.png",
      "/projects/neokart/2.png",
      "/projects/neokart/3.png",
    ],
    featured: false,
  },
  {
    id: "pysummarizer",
    title: "PySummarizer — AI Summary App",
    description:
      "React and Flask-powered text summarizer leveraging Google T5 NLP model, with user session handling, automated email dispatch, and database persistence.",
    tech: ["Python", "Flask", "React", "MySQL", "T5 Model"],
    category: "Full Stack / AI",
    isPrivate: false,
    github: "https://github.com/GulrezSarankar/Summary-Generator.git",
    link: "https://summary-inky.vercel.app/",
    images: [
      "/projects/summary/1.png",
      "/projects/summary/2.png",
      "/projects/summary/3.png",
    ],
    featured: false,
  },
  {
    id: "sams",
    title: "SAMS — Attendance Management",
    description:
      "Smart Attendance Management System (SAMS) delivering real-time student tracking, automated reports, and executive dashboard metrics.",
    tech: ["React", "FastAPI", "Python", "MySQL", "Tailwind CSS"],
    category: "Full Stack",
    isPrivate: false,
    github: "https://github.com/GulrezSarankar/SAMS.git",
    link: "https://society-affair-management-system.vercel.app/",
    images: [
      "/projects/sams/1.png",
      "/projects/sams/2.png",
      "/projects/sams/3.png",
    ],
    featured: false,
  },
];
